import { render, staticRenderFns } from "./TableInvItems.vue?vue&type=template&id=95773fa4&scoped=true"
import script from "./TableInvItems.vue?vue&type=script&lang=js"
export * from "./TableInvItems.vue?vue&type=script&lang=js"
import style0 from "./TableInvItems.vue?vue&type=style&index=0&id=95773fa4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "95773fa4",
  null
  
)

export default component.exports